export default __webpack_public_path__ + "static/media/partner-rapid.78318638.jpg";